export const isEmpty = (value) => {
    return (
        value === undefined ||
        value === "undefined" ||
        value === null ||
        value === "null" ||
        Number.isNaN(value) ||
        (typeof value === "object" && Object.keys(value).length === 0) ||
        (typeof value === "string" && value.trim().length === 0)
    );
};